(() => {
  const legalPaths = [
    '/pages/privacy-policy',
    '/pages/terms-of-service',
    '/pages/legal-notice',
    '/pages/returns',
    '/pages/contact'
  ];

  const isRelevantPage = legalPaths.some((path) => window.location.pathname.endsWith(path) || window.location.pathname.endsWith(`${path}/`));
  if (!isRelevantPage) return;

  const updateLegalNames = () => {
    const root = document.querySelector('#MainContent') || document.body;
    if (!root) return;

    root.innerHTML = root.innerHTML
      .replace(/<strong>\s*Hellberg Commerce\s*<\/strong>\s*<br\s*\/?>\s*Finn Hellberg/gi, '<strong>Per Hellberg</strong>')
      .replace(/Hellberg Commerce\s*<br\s*\/?>\s*Finn Hellberg/gi, 'Per Hellberg')
      .replace(/<strong>\s*Hellberg Commerce\s*<\/strong>/gi, '<strong>Per Hellberg</strong>')
      .replace(/Hellberg Commerce/gi, 'Per Hellberg')
      .replace(/Finn Hellberg/gi, 'Per Hellberg');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLegalNames);
  } else {
    updateLegalNames();
  }
})();